<template>
	<div class="operations">
		<div class="warinTitle" v-if="warnProjectList.length>0">{{warnVal}}</div>
		<!--c_name/name-->
		<div id="map" style="width:100%;height:100%;position: relative;" @click.stop="mapClick"></div>
		<div class="noBox" @click="centerClick">
			<i class="iconfont icon-quanping-fangda-07"></i>
		</div>
		<div class="allBox" @click="screen">
			<i class="iconfont icon-quanpingfangda" v-if="!this.fullscreen"></i>
			<i class="iconfont icon-quanpingsuoxiao" v-if="this.fullscreen"></i>
		</div>

		<div class="searchBox">
			<el-autocomplete prefix-icon="el-icon-search" class="inline-input inputClass" v-model="username" :fetch-suggestions="querySearch" placeholder="请输入客户名称" :trigger-on-focus="false" @select="handleSelect" style="width:100%" @input="searchInput"></el-autocomplete>
		</div>
		<div class="warningBox" v-if="warningShow">
			<div class="customerClass">{{currentWarnObj.c_name}}</div>
			<el-radio-group v-model="tabPosition" style="width:95%" @change="tabClick">
				<el-radio-button label="报警设备" style="width:50%">报警设备{{projectUnendEventList.length}}</el-radio-button>
				<el-radio-button label="离线网关" style="width:50%">离线网关{{total}}</el-radio-button>
			</el-radio-group>
			<!--报警设备-->
			<div class="warningList" v-if="tableShow1">
				<div class="warningContent" @click="warningContentClick(item.device_id)" v-for="item in projectUnendEventList">
					<div class="topClass">
						<span class="typeClass">{{item.category}} {{item.event_name}}</span>
						<span class="signClass">{{item.event_lev|event_levFilter}}</span>
					</div>
					<div style="border: 1px solid #ccc;">
						<div class="urlClass">
							<span class="typeClass2">{{item._path}}</span>
							<span class="signClass2"><i class="el-icon-arrow-right
"></i></span>
						</div>
						<div class="lastClass">
							<span class="timeClass">{{item.data_time}}</span>
							<div class="sendClass">
								<span>{{item.event_status|event_statusFilter}}</span>
								<i class="iconfont icon-duihao1" style="color: #0063FF;" v-if="item.event_status==3"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--离线网关-->
			<div class="warningList" v-if="tableShow2">
				<div class="warningContent" @click="gateOffClick(item.gateway_id)" v-for="item in gateway_logList">
					<div style="border: 1px solid #ccc;">
						<div class="urlClass" style="margin-top: 6px;">
							<span class="typeClass">{{item._path}}</span>
							<span class="signClass"><i class="el-icon-arrow-right
"></i></span>
						</div>
						<div class="lastClass" style="margin-bottom: 4px;">
							<span class="timeClass">{{item.create_time}}</span>
							<div class="sendClass">
								<span>{{item.event_status|event_statusFilter}}</span>
								<i class="iconfont icon-duihao1" style="color: #0063FF;" v-if="item.event_status==3"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<el-pagination small @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, prev, pager, next" :total="total" v-if="total>20&&tableShow2">
				</el-pagination>
			</div>
		</div>
		<div class="levBox">
			<div class="mapLev">地图级别：{{mapLev}}</div>
			<button class="defaultButton" @click="defaultLevClick">点击保存为默认级别</button>
		</div>
		<!--弹窗1-->
		<el-dialog title="" :visible.sync="dialogFormVisible" :width="dialogWidth1" :close-on-click-modal="false">
			<el-table :data="event_deviceList" style="width: 100%" v-loading="loading1" border>
				<el-table-column prop="data_time" label="发生时间" min-width="2%">
				</el-table-column>
				<el-table-column prop="_path" label="发生位置" min-width="3%">
				</el-table-column>
				<el-table-column prop="link_man" label="报警数汇总" min-width="3%">
					<template slot-scope="scope">
						高风险{{scope.row.h_num}}、中风险{{scope.row.m_num}}、低风险{{scope.row.l_num}}
					</template>
				</el-table-column>
				<el-table-column prop="link_tel" label="发送状态" min-width="2%">
					<template slot-scope="scope">
						{{scope.row.status|statusFilter}}
					</template>
				</el-table-column>
				<el-table-column prop="gateway_addr" label="上报通讯地址" min-width="2%">
				</el-table-column>
				<el-table-column prop="device_addr" label="通讯地址" min-width="2%">
				</el-table-column>
				<el-table-column prop="address" label="操作" min-width="2%">
					<template slot-scope="scope">
						<a class="editClass" @click="detailClick(scope.row.device_id,scope.row.id)">查看详细</a>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<!--弹窗2-->
		<div class="specliDialog">
			<el-dialog title="" :visible.sync="dialogFormVisible2" :width="dialogWidth2" :close-on-click-modal="false">
				<div class="iconBox">
					<div class="backIcon">
						<i class="el-icon-arrow-left iconClass" @click="backIconClick('2')"></i>
					</div>
					<div class="closeIcon">
						<i class="el-icon-close iconClass" @click="closeIconClick('2')"></i>
					</div>
				</div>
				<div class="detailBox">
					<div class="modelClass">设备型号：{{subprojectObj.model}}</div>
					<div class="codeClass">设备编号：{{subprojectObj.code}}</div>
					<div class="seturlClass">发生位置：{{urlValue}}/{{subprojectObj.name}}</div>
				</div>
				<el-table :data="detailList" style="width: 100%" v-loading="loading2" border>
					<el-table-column prop="" label="级别" min-width="1%">
						<template slot-scope="scope">
							<div class="signBox1" v-if="scope.row.event_lev==3">{{scope.row.event_lev|event_levFilter}}</div>
							<div class="signBox2" v-if="scope.row.event_lev==2">{{scope.row.event_lev|event_levFilter}}</div>
							<div class="signBox3" v-if="scope.row.event_lev==1">{{scope.row.event_lev|event_levFilter}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="data_time" label="发生时间" min-width="3%">
					</el-table-column>
					<el-table-column prop="event_end" label="结束时间" min-width="3%">
					</el-table-column>
					<el-table-column prop="event_name" label="类别" min-width="2%">
					</el-table-column>
					<el-table-column prop="address" label="操作" min-width="1%">
						<template slot-scope="scope">
							<a class="editClass" @click="currentClick(scope.row.id,scope.row.data_item_id)">查看当时值</a>
						</template>
					</el-table-column>
				</el-table>
			</el-dialog>
		</div>
		<!--弹窗3-->
		<div class="specliDialog">
			<el-dialog title="" :visible.sync="dialogFormVisible3" :width="dialogWidth3" :close-on-click-modal="false">
				<div class="iconBox">
					<div class="backIcon">
						<i class="el-icon-arrow-left iconClass" @click="backIconClick('3')"></i>
					</div>
					<div class="closeIcon">
						<i class="el-icon-close iconClass" @click="closeIconClick('3')"></i>
					</div>
				</div>
				<div class="titleBox">
					报警时数据
				</div>
				<div class="contentDialog">
					<div class="contentValue" v-for="item in currentList">{{item.title}}：{{item.val}}{{item.unit_name}}</div>
				</div>
			</el-dialog>
		</div>
		<!--弹窗4-->
		<el-dialog title="" :visible.sync="dialogFormVisible4" :width="dialogWidth3" :close-on-click-modal="false">
			<el-table :data="eventData" style="width: 100%" v-loading="loading" border>
				<el-table-column prop="create_time" label="发生时间" min-width="1%">
				</el-table-column>
				<el-table-column prop="link_tel" label="发送状态" min-width="1%">
					<template slot-scope="scope">
						{{scope.row.event_status|statusFilter}}
					</template>
				</el-table-column>
				<el-table-column prop="addr" label="上报通讯地址" min-width="1%">
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	var mapLev = 6;

	function ZoomControl() {
		// 设置默认停靠位置和偏移量  
		this.defaultAnchor = BMAP_ANCHOR_TOP_RIGHT;
		this.defaultOffset = new BMap.Size(410, 12);
	}
	// 通过JavaScript的prototype属性继承于BMap.Control   
	ZoomControl.prototype = new BMap.Control();
	// 自定义控件必须实现initialize方法，并且将控件的DOM元素返回   
	// 在本方法中创建个div元素作为控件的容器，并将其添加到地图容器中
	ZoomControl.prototype.initialize = function(map) {
		//创建一个DIV
		var mydiv = document.createElement("div");
		mydiv.style.color = "#666";
		//减号按钮
		var img_minusdiv = document.createElement("div");
		img_minusdiv.style.width = "20px";
		img_minusdiv.style.height = "20px";
		img_minusdiv.style.lineHeight = "20px";
		img_minusdiv.style.textAlign = "center";
		img_minusdiv.style.border = "1px solid #999";
		img_minusdiv.style.boxShadow = "0 0 6px #000";
		img_minusdiv.style.display = "inline-block";
		img_minusdiv.style.marginRight = "10px";
		img_minusdiv.style.backgroundColor = "#fff";
		img_minusdiv.style.cursor = "pointer";
		img_minusdiv.style.boxShadow = " 0 0 6px #999999";
		var img_minus = document.createElement("i");
		img_minus.setAttribute("class", "iconfont icon-jianhao");
		var _this = this;
		img_minus.onclick = function() {
			map.zoomTo(map.getZoom() - 1);
			mapLev = mapLev - 1
			getMapLev();
		}
		img_minusdiv.appendChild(img_minus);
		mydiv.appendChild(img_minusdiv);
		//加号按钮
		var img_plusdiv = document.createElement("div");
		img_plusdiv.style.width = "20px";
		img_plusdiv.style.height = "20px";
		img_plusdiv.style.lineHeight = "20px";
		img_plusdiv.style.textAlign = "center";
		img_plusdiv.style.border = "1px solid #999";
		img_plusdiv.style.boxShadow = "0 0 6px #000";
		img_plusdiv.style.display = "inline-block";
		img_plusdiv.style.marginRight = "10px";
		img_plusdiv.style.backgroundColor = "#fff";
		img_plusdiv.style.cursor = "pointer";
		img_plusdiv.style.boxShadow = " 0 0 6px #999999";
		var img_plus = document.createElement("i");
		img_plus.setAttribute("class", "iconfont icon-jiahao1");
		img_plus.onclick = function() {
			map.zoomTo(map.getZoom() + 1);
			mapLev = mapLev + 1
			getMapLev();
		}
		img_plusdiv.appendChild(img_plus);
		mydiv.appendChild(img_plusdiv);
		//		//no按钮
		//		var nodiv = document.createElement("div");
		//		nodiv.style.width = "20px";
		//		nodiv.style.height = "20px";
		//		nodiv.style.lineHeight = "20px";
		//		nodiv.style.textAlign = "center";
		//		nodiv.style.border = "1px solid #999";
		//		nodiv.style.boxShadow = "0 0 6px #000";
		//		nodiv.style.display = "inline-block";
		//		nodiv.style.marginRight = "10px";
		//		nodiv.style.backgroundColor = "#fff";
		//		nodiv.style.cursor = "pointer";
		//		var no = document.createElement("i");
		//		no.setAttribute("class", "iconfont icon-quanping-fangda-07 fontSize");
		//		no.onclick = function() {
		//			//			map.zoomTo(map.getZoom() + 1);
		//		}
		//		nodiv.appendChild(no);
		//		mydiv.appendChild(nodiv);
		//全屏按钮
		//		var alldiv = document.createElement("div");
		//		alldiv.style.width = "20px";
		//		alldiv.style.height = "20px";
		//		alldiv.style.lineHeight = "20px";
		//		alldiv.style.textAlign = "center";
		//		alldiv.style.border = "1px solid #999";
		//		alldiv.style.boxShadow = "0 0 6px #000";
		//		alldiv.style.display = "inline-block";
		//		alldiv.style.marginRight = "10px";
		//		alldiv.style.backgroundColor = "#fff";
		//		alldiv.style.cursor = "pointer";
		//		var all = document.createElement("i");
		//		all.setAttribute("class", "iconfont icon-quanpingfangda fontSize");
		//		all.onclick = function() {
		//			console.log(this.b_id)
		//			//			map.zoomTo(map.getZoom() + 1);
		//		}
		//		alldiv.appendChild(all);
		//		mydiv.appendChild(alldiv);
		//		//搜索框
		//		var input = document.createElement("input");
		//		input.style.width = "340px";
		//		input.style.height = "26px";
		//		input.style.border = "none";
		//		input.style.outline = "none";
		//		input.style.borderRadius = "4px";
		//		input.style.boxShadow = "0 0 6px #000";
		//		input.style.textIndent = "10px";
		//		input.style.fontSize = "13px";
		//		mydiv.appendChild(input);

		//添加DOM元素到地图中
		map.getContainer().appendChild(mydiv);
		//将DOM元素返回；
		return mydiv;
	}
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			window.getMapLev = this.getMapLev; //定义为全局函数
			if(window.sessionStorage.getItem('mapLev')) {
				this.mapLev = Number(window.sessionStorage.getItem('mapLev'))
				mapLev = Number(window.sessionStorage.getItem('mapLev'))
			} else {
				this.mapLev = mapLev
			}
			this.b_id = window.sessionStorage.getItem('b_id')
			this.getEventProjectFun(); //获取B端下报警提示
			this.getCustomerList(); //客户列表
			this.mapAllFun(); //地图初始化

			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth1 = "100%"
					this.dialogWidth2 = "100%"
					this.dialogWidth3 = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth1 = "90%%"
					this.dialogWidth2 = "80%"
					this.dialogWidth3 = "58%"
				} else {
					this.dialogWidth1 = "80%"
					this.dialogWidth2 = "70%"
					this.dialogWidth3 = "38%"
				}
			})
		},
		filters: {
			event_levFilter: function(val) {
				if(val == "1") {
					return "低风险";
				}
				if(val == "2") {
					return "中风险";
				}
				if(val == "3") {
					return "高风险";
				}
			},
			event_statusFilter: function(val) {
				if(val == "0") {
					return "待发送";
				}
				if(val == "1") {
					return "发送成功";
				}
				if(val == "2") {
					return "发送失败";
				}
				if(val == "3") {
					return "已发送，已收到";
				}
			},
			statusFilter: function(val) {
				if(val == "0") {
					return "待发送";
				}
				if(val == "1") {
					return "发送成功";
				}
				if(val == "2") {
					return "发送失败";
				}
				if(val == "3") {
					return "已收到";
				}
			},
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth1 = "100%"
				this.dialogWidth2 = "100%"
				this.dialogWidth3 = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth1 = "90%"
				this.dialogWidth2 = "58%"
				this.dialogWidth3 = "70%"
			} else {
				this.dialogWidth = "80%"
				this.dialogWidth2 = "70%"
				this.dialogWidth3 = "38%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				map: null,
				localLongitude: 120.19, //本地经度
				localLatitude: 30.26, //本地纬度
				mapLev: 0, //地图等级
				b_id: '', //b_id
				dialogFormVisible: false,
				dialogFormVisible2: false,
				dialogFormVisible3: false,
				dialogFormVisible4: false,
				dialogWidth1: '80%', //dialog的宽度
				dialogWidth2: '70%', //dialog的宽度
				dialogWidth3: '38%', //dialog的宽度
				warningShow: false,
				makerShow: false,
				tabPosition: '报警设备',
				tableShow1: true,
				tableShow2: false,
				tableData: [],
				loading: false, //加载状态
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				fullscreen: false,
				/*所有项目列表*/
				projectList: [], //项目列表
				/*列表获取B端下报警提示*/
				warnProjectList: [], //B端下报警提示列表
				warnList: [],
				warnVal: '',
				currentWarnObj: {}, //当前报警对象
				projectUnendEventList: [], //获取某项目下所有未结束的事件列表（报警设备）
				event_deviceList: [], //某设备历史报警列表
				urlValue: '', //设备路径
				subprojectObj: {}, //项目信息
				detailList: [], //报警信息详细列表
				currentList: [], //查看当时值列表
				loading1: false,
				loading2: false,
				gateway_logList: [], //某项目网关离线列表
				eventData: [], ///
				/*搜索*/
				restaurants: [], //客户列表
				username: '',
			}
		},
		methods: {
			//获取B端下报警提示
			getEventProjectFun() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getEventProject')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/screenShow/getEventProject', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.warnProjectList = res.data
						this.lbFun(); //报警轮播
					} else {
						this.warnProjectList = []
					}
					this.getByBList(); //所有项目列表
				}).catch(err => {
					console.log(err)
				})
			},
			//重复轮播数据
			lbFun() {
				this.warnList = []
				this.warnProjectList.forEach(item => {
					item = item.name + '/' + item.c_name + '有报警'
					this.warnList.push(item)
				})
				for(var i = 0; i < this.warnList.length; i++) {
					var j = 0;
					var t1 = setTimeout(() => {
						this.warnVal = this.warnList[j++]
						if(j == this.warnList.length) {
							var t2 = setTimeout(() => {
								this.lbFun()
							}, 3000)
						}
					}, i * 3000)
				}
			},
			/*地图初始化*/
			mapAllFun() {
				/*初始化地图*/
				this.map = new BMap.Map("map"); // 创建Map实例
				this.map.centerAndZoom(new BMap.Point(this.localLongitude, this.localLatitude), this.mapLev); // 初始化地图,设置中心点坐标和地图级别
				//添加地图类型控件
				this.map.addControl(new BMap.MapTypeControl({
					mapTypes: [
						BMAP_NORMAL_MAP, //地图模式
					]
				}));
				this.map.setCurrentCity("杭州");
				//styleJson地图样式
				//styleJson地图样式
				var styleJson = [{
						"featureType": "land",
						"elementType": "geometry",
						"stylers": {
							"visibility": "on",
							"color": "#FEFFFFFF"
						}
					}, {
						"featureType": "water",
						"elementType": "geometry",
						"stylers": {
							"visibility": "on",
							"color": "#69AEE7ff"
						}
					},
					//文字
					{
						"featureType": "all",
						"elementType": "labels.text.fill",
						"stylers": {
							"color": "#2da0c6",
							"visibility": "off"
						}
					},
					//网格
					{
						'featureType': 'road',
						"elementType": 'all',
						'stylers': {
							'visibility': 'off'
						}
					}, {
						"featureType": "city",
						"elementType": "labels.icon",
						"stylers": {
							"visibility": "off"
						}
					},

				]
				/*this.map.setMapStyleV2({
					styleId: '396bf7ded5259a4198730fc9ec45d522'
				})*/
				this.map.setMapStyleV2({
					styleJson: styleJson
				})
				var myZoomCtrl = new ZoomControl(); // 创建控件实例 （自定义控件必须有）   
				this.map.addControl(myZoomCtrl); // 添加到地图当中    
			},
			/*绘点fun*/
			mapHDFun() {
				this.projectList.forEach(item => {
					item.point = item.longitude + '|' + item.latitude
				})
				var point = []; //定义数组标注经纬信息
				var marker = []; //定义数组点对象信息
				/*渲染多个地图绘点*/
				if(document.createElement('canvas').getContext) { // 判断当前浏览器是否支持绘制海量点
					for(var i = 0; i < this.projectList.length; i++) { //遍历
						var infoA = this.projectList[i].point.split("|")[0]; //分割|
						var infoB = this.projectList[i].point.split("|")[1];
						var icon;
						if(this.projectList[i].warnSign) {
							icon = new BMap.Icon(require('../../assets/red2.png'), new BMap.Size(50, 50));
						} else {
							icon = new BMap.Icon(require('../../assets/greenSign.png'), new BMap.Size(50, 50));
						}
						point[i] = new window.BMap.Point(infoA, infoB);
						marker[i] = new window.BMap.Marker(point[i], {
							icon: icon
						});
						this.map.addOverlay(marker[i]);
						var _this = this
						marker[i].addEventListener('click', function(e) {
							var p = e.target;
							_this.projectList.forEach(item => {
								if(item.longitude == p.getPosition().lng && item.latitude == p.getPosition().lat) {
									_this.currentWarnObj = item
									_this.getProjectUnendEventList(); //获取某项目下所有未结束的事件列表		
									_this.getGateway_logList(); //某项目网关离线列表
									if(item.warnSign) {
										e.domEvent.stopPropagation();
										_this.makerShow = true
										_this.warningShow = true
									}
								}
							})
						});
					}
				} else {
					alert('请在chrome、safari、IE8+以上浏览器查看本示例');
				}
			},
			//所有项目列表
			getByBList() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/project/getByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.projectList = res.data
						/*报警标识处理*/
						this.projectList.forEach(item => {
							item.warnSign = false
							this.warnProjectList.forEach(item_w => {
								if(item_w.id == item.id) {
									item.warnSign = true
								}
							})
						})
						this.mapHDFun()
					} else {
						this.projectList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//全屏
			screen() {   
				let fullarea = document.getElementsByClassName('operations')[0]
				let element = document.documentElement;   
				if(this.fullscreen) {    
					if(document.exitFullscreen) {     
						document.exitFullscreen();    
					} else if(document.webkitCancelFullScreen) {     
						document.webkitCancelFullScreen();    
					} else if(document.mozCancelFullScreen) {     
						document.mozCancelFullScreen();    
					} else if(document.msExitFullscreen) {     
						document.msExitFullscreen();    
					}   
				} else {    
					if(element.requestFullscreen) {    
						//element.requestFullscreen();
						fullarea.requestFullscreen();    
					} else if(element.webkitRequestFullScreen) {     
						element.webkitRequestFullScreen();    
					} else if(element.mozRequestFullScreen) {     
						element.mozRequestFullScreen();    
					} else if(element.msRequestFullscreen) {      // IE11
						element.msRequestFullscreen();    
					}   
				}   
				this.fullscreen = !this.fullscreen;  
			},
			//获取某项目下所有未结束的事件列表
			getProjectUnendEventList() {
				var params = {
					project_id: this.currentWarnObj.id
				}
				//console.log(params)
				let config = headers.headers('getProjectUnendEvent')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event/getProjectUnendEvent', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.projectUnendEventList = res.data
					} else {
						this.projectUnendEventList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//报警设备列表的点击
			warningContentClick(device_id) {
				this.dialogFormVisible = true
				this.getEvent_deviceList(device_id);
			},
			//某设备历史报警列表
			getEvent_deviceList(device_id) {
				this.loading1 = true;
				var params = {
					pageSize: -1,
					pageIndex: 1,
					device_id: device_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event_device/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading1 = false;
					//console.log(res)
					if(res.data.length > 0) {
						this.event_deviceList = res.data
					} else {
						this.event_deviceList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//查看详细
			detailClick(device_id, event_device_id) {
				this.getDeviceObj(device_id);
				this.getFaultalarmList(event_device_id);
				this.dialogFormVisible2 = true
			},
			//设备信息
			getDeviceObj(device_id) {
				//console.log(params)
				var params = {}
				var config1 = headers.headers(device_id)
				var pass_token = config1.pass_token
				var timestamp = config1.timestamp
				axios.get(this.http + '/zkep2/device/' + device_id, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					if(res.data.id) {
						var params = {
							id: res.data.subproject_id
						}
						let config = headers.headers('getPath')
						var pass_token = config.pass_token
						var timestamp = config.timestamp
						axios.get(this.http + '/zkep2/subproject/getPath', {
							params,
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							if(res.data) {
								this.urlValue = res.data
							} else {
								this.urlValue = ''
							}
						}).catch(err => {
							console.log(err)
						})
						let config2 = headers.headers(res.data.subproject_id)
						var pass_token = config2.pass_token
						var timestamp = config2.timestamp
						axios.get(this.http + '/zkep2/subproject/' + res.data.subproject_id, {
							params,
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							if(res.data.id) {
								this.subprojectObj = res.data
							} else {
								this.subprojectObj = {}
							}
						}).catch(err => {
							console.log(err)
						})
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//报警信息列表
			getFaultalarmList(event_device_id) {
				this.loading2 = true;
				var params = {
					pageSize: -1,
					pageIndex: 1,
					event_device_id: event_device_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading2 = false;
					//console.log(res)
					if(res.data.length > 0) {
						this.detailList = res.data
					} else {
						this.detailList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//查看当时值
			currentClick(event_id, data_item_id) {
				this.dialogFormVisible3 = true
				var params = {
					event_id: event_id,
				}
				//console.log(params)
				let config = headers.headers('getByEvent')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event_detail/getByEvent', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.currentList = res.data
					} else {
						var params1 = {}
						var config1 = headers.headers(data_item_id)
						var pass_token = config1.pass_token
						var timestamp = config1.timestamp
						axios.get(this.http + '/zkep2/data_item/' + data_item_id, {
							params1,
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							this.getRwo(res.data.data_id)
						}).catch(err => {
							console.log(err)
						})
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//备份列表
			getRwo(data_id) {
				var params = {
					data_id: data_id
				}
				let config = headers.headers('getByDataWithTitle')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/data_item/getByDataWithTitle', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.currentList = res.data
					} else {
						this.currentList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//tab的点击
			tabClick(val) {
				if(val == '报警设备') {
					this.tableShow1 = true;
					this.tableShow2 = false;
				} else if(val == '离线网关') {
					this.tableShow1 = false;
					this.tableShow2 = true;
				}
			},
			/*
			 * 离线列表
			 * */
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getGateway_logList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getGateway_logList();
			},
			getGateway_logCount() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					project_id: this.currentWarnObj.id
				}
				//console.log(params)
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/gateway_log/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//某项目网关离线列表
			getGateway_logList() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					project_id: this.currentWarnObj.id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/gateway_log/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.getGateway_logCount()
					//console.log(res)
					if(res.data.length > 0) {
						this.gateway_logList = res.data
					} else {
						this.gateway_logList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//离线网关列表的点击
			gateOffClick(gateway_id) {
				this.dialogFormVisible4 = true
				this.getGateway_logDetailList(gateway_id)
			},
			//某项目网关离线详细列表
			getGateway_logDetailList(gateway_id) {
				var params = {
					pageSize: -1,
					pageIndex: 1,
					gateway_id: gateway_id,
				}
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/gateway_log/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.eventData = res.data
					} else {
						this.eventData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//返回
			backIconClick(val) {
				if(val == '2') {
					this.dialogFormVisible2 = false
				} else if(val == '3') {
					this.dialogFormVisible3 = false
				}
			},
			//关闭
			closeIconClick(val) {
				if(val == '2') {
					this.dialogFormVisible = false
					this.dialogFormVisible2 = false
				} else if(val == '3') {
					this.dialogFormVisible = false
					this.dialogFormVisible2 = false
					this.dialogFormVisible3 = false
				}
			},
			//地图的点击事件
			mapClick() {
				this.makerShow = false
				this.warningShow = false
			},
			//地图级别
			getMapLev() {
				this.mapLev = mapLev;
			},
			//中心点
			centerClick() {
				if(window.sessionStorage.getItem('mapLev')) {
					this.mapLev = Number(window.sessionStorage.getItem('mapLev'))
				} else {
					this.mapLev = 6
				}
				this.mapAllFun();
				this.getByBList();
			},
			//默认地图等级
			defaultLevClick() {
				window.sessionStorage.setItem('mapLev', this.mapLev)
			},
			/*
			 * 客户的搜索
			 * */
			//客户的搜索
			searchInput() {
				if(!this.username) {
					this.getByBList()
				}
			},
			//获取客户列表
			getCustomerList() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
					b_id: this.b_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.restaurants = res.data
						this.restaurants.forEach(item => {
							item.value = item.name
						})
					} else {
						this.restaurants = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			/*搜索客户列表*/
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return(restaurant) => {
					return(restaurant.value.toLowerCase().indexOf(queryString) > -1);
				};
			},
			handleSelect(item) {
				var params = {
					pageSize: -1,
					pageIndex: 1,
					c_id: item.id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/project/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						/*清除绘点*/
						var allOverlay = this.map.getOverlays();
						for(var i = 0; i < allOverlay.length; i++) {
							this.map.removeOverlay(allOverlay[i]);
						}
						this.projectList = res.data
						this.projectList.forEach(item => {
							item.warnSign = false
							this.warnProjectList.forEach(item_w => {
								if(item_w.id == item.id) {
									item.warnSign = true
								}
							})
						})
						/*控制报警提示*/
						var j = 0;
						this.projectList.forEach(item => {
							if(!item.warnSign) {
								j++;
							}
						})
						if(j == this.projectList.length) {
							this.$message('当前无报警！')
						}
						this.mapHDFun();
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style>
	.operations {
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	.operations .warinTitle {
		position: absolute;
		top: 2px;
		left: 0;
		z-index: 4;
		width: 19%;
		background: #000;
		opacity: 0.7;
		height: 30px;
		line-height: 30px;
		font-size: 13px;
		color: #fff;
		font-weight: 600;
		text-align: center;
	}
	/*去掉百度地图的图标*/
	
	.operations .BMap_cpyCtrl {
		display: none;
	}
	
	.operations .anchorBL {
		display: none;
	}
	
	.operations .searchBox {
		z-index: 2;
		position: absolute;
		top: 8px;
		right: 8px;
		padding: 0;
		width: 344px;
	}
	
	.operations .inputClass {
		box-shadow: 0 0 6px #999999;
	}
	
	.operations .el-input__inner {
		height: 32px;
		line-height: 32px;
		font-size: 13px;
	}
	
	.operations .el-input__icon {
		line-height: 32px;
	}
	
	.operations .noBox {
		display: inline-block;
		z-index: 6;
		position: absolute;
		top: 12px;
		right: 390px;
		padding: 0;
		width: 20px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		border: 1px solid #ccc;
		background-color: #fff;
		box-shadow: 0 0 6px #999999;
		cursor: pointer;
	}
	
	.operations .allBox {
		display: inline-block;
		z-index: 5;
		position: absolute;
		top: 12px;
		right: 360px;
		padding: 0;
		width: 20px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		border: 1px solid #ccc;
		background-color: #fff;
		box-shadow: 0 0 6px #999999;
		cursor: pointer;
	}
	
	.operations .el-input__inner:focus {
		border: 1px solid #999;
		/*输入框获取焦点时给边框加颜色*/
	}
	
	.operations .el-input__inner {
		border: 1px solid #999;
	}
	
	.operations .el-input__icon {
		color: #333;
	}
	
	.operations input::-webkit-input-placeholder {
		color: #333!important;
	}
	
	.operations .warningBox {
		font-size: 13px;
		position: absolute;
		top: 48px;
		right: 8px;
		z-index: 3;
		width: 343px;
		height: 83%;
	}
	
	.operations .customerClass {
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		margin-bottom: 8px;
		text-indent: 14px;
		box-shadow: 0 0 6px #999999;
	}
	
	.operations .el-radio-button__inner {
		padding: 10px 33%;
	}
	
	.operations .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: #0063FF;
	}
	
	.operations .el-radio-button__inner {
		color: #0063FF;
	}
	
	.operations .warningList {
		height: 78%;
		overflow: auto;
		margin-bottom: 3px;
	}
	
	.operations .warningContent {
		background-color: #fff;
		margin-bottom: 4px;
	}
	
	.operations .topClass {
		height: 32px;
		line-height: 32px;
		text-indent: 5px;
		background-color: #B20202;
		color: #fff;
	}
	
	.operations .typeClass {
		display: inline-block;
		width: 74%;
	}
	
	.operations .typeClass2 {
		display: inline-block;
		width: 86%;
	}
	
	.operations .signClass {
		display: inline-block;
		width: 20%;
		text-align: right;
	}
	
	.operations .signClass2 {
		display: inline-block;
		width: 8%;
		text-align: right;
	}
	
	.operations .urlClass {
		/*height: 30px;*/
		line-height: 24px;
		text-indent: 5px;
		margin-bottom: 4px;
		margin-top: 2px;
	}
	
	.operations .lastClass {
		height: 40px;
		line-height: 40px;
		text-indent: 5px;
		color: #ccc;
	}
	
	.operations .timeClass {
		display: inline-block;
		width: 50%;
	}
	
	.operations .sendClass {
		display: inline-block;
		text-align: right;
		width: 40%;
	}
	/*表格*/
	
	.operations .el-table th {
		color: #000;
	}
	
	.operations .el-table {
		font-size: 12px;
	}
	
	.operations .el-table th,
	.operations .el-table td,
	.operations .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: center;
	}
	
	.operations .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: center;
		color: #fff;
		background-color: #164B8F;
	}
	/*表头错位*/
	
	.operations .el-table--border th.gutter:last-of-type {
		display: block!important;
		width: 17px!important;
	}
	
	.operations .editClass {
		color: #0063FF;
		cursor: pointer;
	}
	
	.operations .specliDialog .el-dialog__headerbtn .el-dialog__close {
		color: #FFF;
	}
	
	.operations .specliDialog .el-dialog__header {
		padding: 0;
	}
	
	.operations .specliDialog .el-dialog__body {
		padding-top: 0;
	}
	
	.operations .iconBox {
		color: #000;
		height: 40px;
		line-height: 40px;
	}
	
	.operations .backIcon {
		display: inline-block;
		width: 50%;
	}
	
	.operations .closeIcon {
		display: inline-block;
		width: 49%;
		text-align: right;
	}
	
	.operations .iconClass {
		cursor: pointer;
		font-weight: bold;
		font-size: 18px;
		color: #000;
	}
	
	.operations .detailBox {
		text-indent: 20px;
		height: 70px;
		width: 70%;
		background-color: #164B8F;
		margin-bottom: 10px;
		color: #fff;
		font-size: 13px;
	}
	
	.operations .modelClass {
		height: 36px;
		line-height: 36px;
		width: 100%;
	}
	
	.operations .codeClass {
		display: inline-block;
		width: 48%;
	}
	
	.operations .seturlClass {
		display: inline-block;
		width: 48%;
	}
	
	.operations .titleBox {
		color: #000;
		margin: 0 40px;
		border-bottom: 1px solid #ccc;
		height: 50px;
		line-height: 50px;
	}
	
	.operations .contentDialog {
		margin: 0 40px 40px 40px;
	}
	
	.operations .contentValue {
		vertical-align: top;
		display: inline-block;
		width: 30%;
		margin-right: 2.5%;
		height: 40px;
		line-height: 26px;
		margin-top: 10px;
		color: #000;
	}
	
	.el-dialog__headerbtn .el-dialog__close {
		color: #000;
		font-size: 18px;
		font-weight: bold;
	}
	/*等级*/
	
	.operations .levBox {
		position: absolute;
		bottom: 10px;
		right: 24px;
		text-align: right;
	}
	
	.operations .mapLev {
		font-size: 12px;
		font-weight: 600;
		margin-bottom: 3px;
	}
	
	.operations .defaultButton {
		background-color: #fff;
		border: none;
		color: #0063FF;
		border-radius: 4px;
		font-size: 10px;
		padding: 2px 4px;
		outline: none;
	}
	
	.signBox1 {
		color: #fff;
		display: inline-block;
		width: 60%;
		height: 20px;
		line-height: 20px;
		background-color: #B7000D;
		border: 1px solid #000;
	}
	
	.signBox2 {
		color: #fff;
		display: inline-block;
		width: 60%;
		height: 20px;
		line-height: 20px;
		background-color: #FC794D;
		border: 1px solid #000;
	}
	
	.signBox3 {
		color: #000;
		display: inline-block;
		width: 60%;
		height: 20px;
		line-height: 20px;
		background-color: #6F706B;
		border: 1px solid #000;
	}
	/*滚动条的样式*/
	
	.warningList::-webkit-scrollbar {
		width: 10px;
	}
	
	.warningList::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	
	.warningList::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
</style>


// WEBPACK FOOTER //
// src/components/Operations/Operations.vue